export type MetaPixelEventName = 'Lead' | 'Contact' | 'Purchase';

export interface MetaPixelEventParams {
  [key: string]: unknown;
}

export const trackMetaPixelEvent = (name: MetaPixelEventName, params: MetaPixelEventParams = {}) => {
  if (typeof window === 'undefined') return;
  window.metaPixelTrackEvent?.(name, params);
};

export const trackMetaPixelLead = (params: MetaPixelEventParams = {}) => {
  trackMetaPixelEvent('Lead', params);
};

export const trackMetaPixelContact = (params: MetaPixelEventParams = {}) => {
  trackMetaPixelEvent('Contact', params);
};

export const trackMetaPixelPurchase = (params: MetaPixelEventParams = {}) => {
  trackMetaPixelEvent('Purchase', params);
};
